export default __webpack_public_path__ + "static/media/9.a2117d10.jpeg";